export * from './src/analytics-semantic-model-v3-semantic-model-analytics-semantic-model.universal.js';
